import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Students = () => {
  return (
    <div className='m-1'>
      <Title text="Estudantes"/>
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Students